import {
  BRANCH_API,
  BRANCH_API_COPY_MENU,
  BRANCH_API_REMOVE,
  BRANCH_API_SORT,
} from "shared/constants/api-endpoint";
import { UpdatedSortEntityModel } from "shared/models/updated-sort-entity-model";
import { apiClient } from "shared/plugins/http-service";
import {
  CreateBranchModel,
  RemovedBranchModel,
  BranchModel,
  UpdatedBranchModel,
} from "./branch.models";

export const getBranchList = async () => {
  return await apiClient.getHttp<BranchModel[]>(`${BRANCH_API}`);
};

export const removeBranch = async (removedModel: RemovedBranchModel) => {
  const response = await apiClient.postHttp(
    `${BRANCH_API_REMOVE}`,
    removedModel
  );
  return response;
};
export const updateSortBranch = async (
  updatedSortModel: UpdatedSortEntityModel<number>[]
) => {
  const response = await apiClient.postHttp(
    `${BRANCH_API_SORT}`,
    updatedSortModel
  );
  return response;
};
export const getBranchById = async (id: number) => {
  return await apiClient.getHttp<BranchModel>(`${BRANCH_API}/${id}`);
};

export const addBranch = async (model: CreateBranchModel) => {
  const response = await apiClient.postHttp<number>(`${BRANCH_API}`, model);
  return response;
};

export const updateBranch = async (model: UpdatedBranchModel) => {
  const response = await apiClient.putHttp<number>(`${BRANCH_API}`, model);
  return response;
};

export const copyMenuFromOtherBranch = async (model: {
  branchId: number;
  fromBranchId: number;
}) => {
  const response = await apiClient.postHttp(`${BRANCH_API_COPY_MENU}`, model);
  return response;
};
